export default "/images/arrow-right2.svg?86bea561cad08e3eb05610a183259c11";